 /*
 * Service: 장바구니 조회 서비스
 * Author: KimHyunSoo
 * Date: 2021-04-26
 */

import GentleWidget from '../common/widget';
import GentleUtil from '../common/util';
import GentleLang from '../common/lang';
import GentleComponentButton from '../component/button';
import GentleComponentBubble from '../component/bubble';
import GentleComponentQuickReply from '../component/quickReply';
import GentleProxy from '../common/proxy';
import GentleServiceProduct from './product';
import GentleAppState from '../common/appstate';
import language from '../lang';
import GentleServiceSearch from './search';
import Const from '../common/const';
import GentleServiceCallCenter from '../service/callCenter'

 var GentleServiceCart = Object.create( GentleWidget,{
     sponserId:{ writable: true, configurable: false, enumerable: true},
     sponserName: { writable: true, configurable: false, enumerable: true}
 })
 
 // 카드 템플릿
 GentleServiceCart.card = function(opts){
     /**
     info:
     buttons: [
         {
             title:
             handler8
         },
         ...        
     ] 
      */
     const element = opts.info;
         
     const html = `
     <div style="border:solid 1px red">
         <image width="100px" src="${element.image}"></image>
         <div>${element.date}</div>
         <div>${element.badge}</div>
         <div>${element.name}</div>
         <div>${element.price}</div>
         <div>${element.pv}</div>
         <div name="buttons" />
     </div>`;
 
     const $card = $(html);
 
     opts.buttons.forEach(button => {
         const html = `
         <button style="border:solid 1px green">${button.title}</button>
         `;
         const $button = $(html);
         $button.bind('click', button.handler);
         
         $card.find('[name="buttons"]').append($button);
     });
     return $card;
 }

 // 장바구니 담기 완료
//  GentleServiceCart.done({Id, amount, Name, totalPrice, totalPv, optionName, ThumbImageUrl});

 GentleServiceCart.done = function(info){
     console.log('GentleServiceCart.done', info);

    const component =  Object.create(this);

    const {amount, id} = info;
    // api : 카트에 담기
    const request = function(){
        const onSuccess = function(data){
            console.log('onSuccess>', data);
            switch(data.result){
            case "200":
                console.log('Data>', data);                
                render(info);
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const param = {
            products: [{
                goodsNo: id,
                quantity: amount
            }]
        }

        const proxy = Object.create(GentleProxy);

        // const formData = new FormData(); // new FromData()로 새로운 객체 생성
        // formData.append("products", JSON.stringify(param));

        // proxy.requestFormData("global-cartAdd", formData, onSuccess, onFailed );
        proxy.request("2025-cartAdd", param, onSuccess, onSuccess );
    }

    const render = function(data){
        console.log('render>', data);
        
        // 봇버블
        {
            const html = GentleLang.translateService(language.cart, language.cart.type.Check);
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        const titleOption = GentleLang.translate(GentleLang.type.Option);
        const titleAmount = GentleLang.translate(GentleLang.type.Amount);
        const titleTotalPrice = GentleLang.translateService(language.order, language.order.type.TotalPrice);
        const titleTotalPV = GentleLang.translate(GentleLang.type.TotalPv);
        const titleShoping = GentleLang.translateService(language.cart, language.cart.type.Shopping);
        const titleCartList = GentleLang.translateService(language.cart, language.cart.type.List);

        {
            const {ThumbImageUrl, name, optionName, amount, totalPv, totalPrice} = data;
            
            let optionDiv = ``
            if(optionName){
                optionDiv = `
                <div class="flex-box-2 space-beetween">
                    <span>${titleOption}</span>
                    <span><strong>${optionName}</strong></span>
                </div>`;
            }

            const price = GentleLang.translate(GentleLang.type.CurrencyFormat, {num: GentleUtil.comma(totalPrice)});
            const pv = GentleUtil.comma(totalPv);
            
            let html = `
            <div class="card-view">
                <div class="product-container cart">
                    <div class="product-card">
                        <figure class="product-thumbnail">
                            <img src="${ThumbImageUrl}">                                
                        </figure>
                        <div class="product-summary-cart">
                            <h3>${name}</h3>                          
                        </div>
                    </div>
                    <hr>
                    ${optionDiv}
                    <div class="flex-box-2 space-beetween">
                        <span>${titleAmount}</span>
                        <span><strong>${amount}</strong></span>
                    </div>
                    <div class="flex-box-2 space-beetween">
                        <span>${titleTotalPrice}</span>
                        <span>${price}</span>
                    </div>
                    <div class="flex-box-2 space-beetween">
                        <span>${titleTotalPV}</span>
                        <span><strong class="pv">${pv}</strong> PV</span>
                    </div>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button type="button" class="primary default" name="shopping">${titleShoping}</button>
                            <button type="button" class="secondary default" name="list">${titleCartList}</button>
                        </div>
                    </div>
                    
                </div>
            </div>`;
            
            const $card = $(html);

            $card.find('[name="shopping"]').bind('click', function(){
                console.log('쇼핑계속하기');
                GentleComponentBubble.insertUserBubble({html:titleShoping, send:false});
                GentleServiceSearch.main()
            });

            $card.find('[name="list"]').bind('click', function(){
                console.log('쇼핑계속하기');
                GentleServiceCart.popupList();
            });

            component.insertElement($card);
        }

        // quickReplay
        {
            const buttons = [
                {
                    title: GentleLang.translate(GentleLang.type.BestProduct),
                    text: GentleLang.translate(GentleLang.type.BestProduct),
                },
                {
                    title: GentleLang.translate(GentleLang.type.NewProduct),
                    text: GentleLang.translate(GentleLang.type.NewProduct),
                },
            ];
            var quickReply = Object.create( GentleComponentQuickReply);   
            quickReply.createComponent(buttons);
            quickReply.insert();
        }
        GentleUtil.timeStamp();
    };

    // if(GentleAppState.isLogin)
    // {
        request();
    // }else{
    //     if(!window.chatbotCart)
    //         window.chatbotCart = [];

    //     window.chatbotCart.push(info)   // 임시카트에 담는다.
    //     console.log('chatbotCart', chatbotCart);

    //     render(info);
    // }
}
 
 GentleServiceCart.main = function(json){ 
       
     const render = function(data){
         // 봇버블
         if(!GentleAppState.isLogin)
         {
            const html = GentleLang.translateService(language.cart, language.cart.type.Click);
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                     html,
             });
            bubble.insert();
            console.log('not login');
         }else
         {
             const html = GentleLang.translateService(language.cart, language.cart.type.MainBot);
             var bubble = Object.create( GentleComponentBubble );   
             bubble.createComponent({
                     html,
             });
             bubble.insert();
         }
 
         // button
         {
             const text = GentleLang.translateService(language.cart, language.cart.type.List);
             const option = [
                 {
                     isHidden: true,
                     send: false,
                     text: text,
                     user: 'user',
                     onClick: function () {
                         console.log('장바구니 보기');
                         GentleServiceCart.popupList();
                     },
                 },
             ]
             var button = Object.create( GentleComponentButton);
             button.createComponent(option);
             button.insert();
         } 
         GentleUtil.timeStamp();
     };

     render(json);
 }


GentleServiceCart.requestNomemberToken = function(param){
    // GentleServiceCallCenter.disabledAPI()
    const json = JSON.stringify(param)

    const onSuccess = function(token){
       console.log('onSuccess>', token);
       token = encodeURIComponent(token)
       // console.log("encoded token", token)
       let url = '';
       if(GentleAppState.isPc)
           url = `https://www.atomy.kr/v2/Home/Payment/NonOrderPaymentExternal?token=${token}@${json}`
       else
           url = `https://m.atomy.com/kr/m/Signin/SetMobileUrlByChatbot?token=${token}@${json}`
       console.log(url);

       window.open(url);
    };

    const onFailed = function(data){
       console.log('onFailed');
    }

    const proxy = Object.create(GentleProxy);
    // const param = {page: page+1, size:pageSize};
    
    proxy.request("nomember-token", {}, onSuccess, onFailed );
}
GentleServiceCart.popupList = function(){
    console.log('GentleServiceCart.popupList')
    //20221017
    // GentleUtil.updateSSOToken();

    // {
    //     const bubble = GentleUtil.notSupported();
    //     bubble.insert();
    //     return;
    // }

    const render = function(array){

        if(array && array.length > 0){}else
        {
            // 사용자 버블
            {
                const html = GentleLang.translateService(language.cart, language.cart.type.List);
                GentleComponentBubble.insertUserBubble({html, send:false});
            }

            // 장바구니가 비어있네요.
            {
                const html = GentleLang.translateService(language.cart, language.cart.type.Empty);
                var bubble = Object.create( GentleComponentBubble );   
                bubble.createComponent({
                        html,
                });
                bubble.insert();
            }

            // 버튼
            {
                {
                    const text = GentleLang.translate(GentleLang.type.AtomyNewProduct);
                    const option = [
                        {
                            // isSecondary: true,
                            // isCardWidth: true,
                            text: text,
                            user: 'user',
                            onClick: function () {
                                console.log('애터미 신상품보기');
                            },
                        },
                    ]
                    var button = Object.create( GentleComponentButton);
                    button.createComponent(option);
                    button.insert();
                }
                // {
                //     const text = GentleLang.translate(GentleLang.type.AtomyBestProduct);
                //     const option = [
                //         {
                //             isSecondary: true,
                //             // isCardWidth: true,
                //             text: text,
                //             user: 'user',
                //             onClick: function () {
                //                 console.log('애터미 인기상품 보기');
                //             },
                //         },
                //     ]
                //     var button = Object.create( GentleComponentButton);
                //     button.createComponent(option);
                //     button.insert();
                // }
            }
            GentleUtil.timeStamp();
            return 
        }

        const title = GentleLang.translate(GentleLang.type.Cart);
        const titleButton = GentleLang.translateService(language.product, language.product.type.Buy);
        const titlePayment = GentleLang.translateService(language.order, language.order.type.TotalPrice);
        const titleProductPrice = GentleLang.translateService(language.cart, language.cart.type.Price);
        const titleDelivery = GentleLang.translateService(language.cart, language.cart.type.Delivery);
        const titlePV = GentleLang.translate(GentleLang.type.TotalPv);

        let totalPrice = 0;
        // totalPrice = GentleLang.translate(GentleLang.type.CurrencyFormat1, {num: totalPrice});
        // price = GentleUtil.comma(price);
        // price = GentleLang.translate(GentleLang.type.CurrencyFormat1, {num: price});

        // 하이브리드 앱 링크 분기
        const browserInfo = window.navigator.userAgent;
        const isHybrid = browserInfo.includes('MARKET_GOOGLE') || browserInfo.includes('MARKET_APPSTORE');

        let post = '';
        let html = `
        <div id="cart-container">
            <ul name="list">
            
            </ul>
            <div id="fixed-bottom-layer">
                <div id="cart-total">
                    <div class="padding-container">
                        <div id="cart-total-price" class="flex-box space-between">
                            <span><strong class="bold">${titlePayment}<em id="cart-count" name="count"></em></strong></span>
                            <span name="payment"></span>
                        </div>
                        <div id="cart-total-price" class="flex-box space-between">
                            <span>${titleProductPrice}</span>
                            <span name="totalPrice"></span>
                        </div>
                        <div id="cart-total-ship" class="flex-box space-between">
                            <span>${titleDelivery}</span>
                            <span name="delivery"></span>
                        </div>
                        <div id="cart-total-pv" class="flex-box space-between">
                            <span>${titlePV}</span>
                            <span><strong class="pv" name="totalPv"></strong> PV</span>
                        </div>
                    </div>
                    <div class="gentle-button-group margin-zero">
                            <div class="wide-button">
                                <form name ="checkout" method = "post" action="https://www.atomy.kr/v2/Home/Payment/OrderPayment" target="_blank">
                                    ${post}
                                    ${isHybrid ? 
                                    `<button type="button" class="square big primary default" 
                                        onclick="location.href='${GentleAppState.isPc ? language.url.pc.BuyNow : language.url.mobile.BuyNow}'"> ${titleButton} </button>` 
                                    : GentleAppState.isPc ? 
                                        `<button type="button" name="buy" class="square big primary default"> ${titleButton} </button>` 
                                        : `<button type="button" class="square big primary default" 
                                            onclick="window.location.href='${GentleAppState.isPc ? language.url.pc.BuyNow : language.url.mobile.BuyNow}'"> ${titleButton} </button>` 
                                    }
                                </form>
                            </div>
                    </div>
                </div>
            </div>
        </div>`;

        const $container = $(html);

        // bind
        const $list = $container.find('[name="list"]');
        const $delivery = $container.find('[name="delivery"]');
        const $count = $container.find('[name="count"]');
        const $payment = $container.find('[name="payment"]');
        const $totalPrice = $container.find('[name="totalPrice"]');
        const $totalPv = $container.find('[name="totalPv"]');
        $container.find('[name="buy"]').bind('click', function(){
            console.log('바로 구매하기');

            let url = GentleAppState.isPc ? language.url.pc.BuyNow : language.url.mobile.BuyNow;
            return GentleUtil.ssoOpen(url);
            // let params = '';
            // let gList = ''
            // let qList = ''

            // const ids = [];
            // const qtt = [];

            // if(GentleAppState.isLogin){
            //     array.forEach(element => {
            //         const {product, quantity} = element;
            //         const {id} = product;

            //         post += `
            //         <input type = "hidden" name = "id" value="${id}">
            //         <input type = "hidden" name = "quantity" value="${quantity}">`;
        
            //         if(gList) gList +=',';
            //         if(qList) qList +=',';
          
            //         // params += `gList=${Id}&qList=${quantity}`;
            //         gList += `${id}`;
            //         qList += `${quantity}`;
            //         params = `gList=${gList}&qList=${qList}`;
            //     });
            // }else if(!GentleAppState.isLogin) {
            //     array.forEach(element => {
            //         // const {ProductInfo, Qty} = element;
            //         // 2022-api : 장바구니 목록
            //         const {product, quantity} = element;
    
            //         const {id} = product;
            //         // 2022-api : 
            //         // const {id:Id, salePrice:CustPrice, pvPrice:PvPrice} = ProductInfo;
    
            //         post += `
            //         <input type = "hidden" name = "id" value="${id}">
            //         <input type = "hidden" name = "quantity" value="${quantity}">`;
        
            //         if(gList) gList +=',';
            //         if(qList) qList +=',';
    
                   
            //         // params += `gList=${Id}&qList=${Qty}`;
            //         gList += `${id}`;
            //         qList += `${quantity}`;
            //         params = `gList=${gList}&qList=${qList}`;
    
            //         ids.push(id);
            //         qtt.push(quantity);
            //     });
            // }
            // console.log('postParams', params);
        
            // // let url = 'https://shop.atomy.com/kr/cart';
            // let url = GentleAppState.isPc ? language.url.pc.BuyNow : language.url.mobile.BuyNow;

            // if(GentleAppState.isLogin){
            //     return GentleUtil.ssoOpen(url.GentleFormat({params}));
            // }
            // else {
            //     console.log('비로그인 구매')

            //     const param = {
            //         id:ids,
            //         Quantity:qtt,
            //         reservationid: 0,
            //     }
            //     return GentleServiceCart.requestNomemberToken(param);

            // }
        });

        const updateTotal = function(array){
            console.log('updateTotal', array);

            let sumPrice = 0; // 상품금액
            let sumPV = 0;
            array.forEach(element => {
                if(GentleAppState.isLogin){
                    const {product, quantity} = element;

                    let totalPV = product.pvPrice * quantity;
                    sumPV += totalPV;
                    
                    let price = product.salePrice * quantity;
                    sumPrice += price;

                }else {
                    const {ProductInfo, Qty} = element;
                    // 2022-api : 장바구니 목록
                    // const {product:ProductInfo, quantity:Qty} = element;

                    const {CustPrice, PvPrice} = ProductInfo;
                    // 2022-api : 
                    // const {id:Id, salePrice:CustPrice, pvPrice:PvPrice} = ProductInfo;

                    
                    let totalPV = PvPrice * Qty;
                    sumPV += totalPV;
                    
                    let price = CustPrice * Qty;
                    sumPrice += price;
                }
            });
            console.log('sumPrice', sumPrice);
            console.log('sumPV', sumPV);

            // totalCount
            {
                let num = array.length;
                console.log('num>', num);
                const text = GentleLang.translate(GentleLang.type.Items, {num});
                $count.html(`(${text})`);
            }

            let delivery = sumPrice >= Const.FreeDeliv ? 0 : Const.Deliv;
            delivery = sumPrice === 0 ? 0 : delivery;   // 구매금액 0

            let payment = sumPrice + delivery;

            delivery = GentleUtil.comma(delivery);
            delivery = GentleLang.translate(GentleLang.type.CurrencyFormat1, {num: delivery});
            $delivery.html(delivery);

            // payment
            {
                payment = GentleUtil.comma(payment);
                const text = GentleLang.translate(GentleLang.type.CurrencyFormat3, {num: payment});
                $payment.html(text);
            }

            // totalPrice
            {
                sumPrice = GentleUtil.comma(sumPrice);
                const text = GentleLang.translate(GentleLang.type.CurrencyFormatBold, {num: sumPrice});
                $totalPrice.html(text);
            }

            // totalPv
            sumPV = GentleUtil.comma(sumPV);
            $totalPv.html(sumPV);
        }
        updateTotal(array);

        // const titleOption = GentleLang.translate(GentleLang.type.Option);
        const titleAmount = GentleLang.translate(GentleLang.type.Amount);
        const titleOrderTotalPrice = GentleLang.translateService(language.order, language.order.type.TotalPrice);
        const titleTotalPv = GentleLang.translate(GentleLang.type.TotalPv);

        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            // console.log(element)


            function elementLoginCheck() {
                if(GentleAppState.isLogin) {
                    const {product, quantity, totalPrice, totalPointValue} = element;
                    return {product, quantity, totalPrice, totalPointValue}
                }else {
                    const {ProductInfo, Qty} = element;
                    return {ProductInfo, Qty}
                }
            };
            // const {ProductInfo, Qty} = element;
            // const {product, quantity, totalPrice, totalPointValue} = element;

            // 2022-api : 장바구니 목록
            // const {product:ProductInfo, quantity:Qty} = element;

            function productLoginCheck() {
                if(GentleAppState.isLogin) {
                    const {name, salePrice, imageUrl, PvPrice, id} = element.product;
                    return {name, salePrice, imageUrl, PvPrice, id}
                }else {
                    const {name, CustPrice, ThumbImageUrl, PvPrice, id} = element.ProductInfo;
                    return {name, CustPrice, ThumbImageUrl, PvPrice, id}
                }
            };

            // const {name, salePrice, images, PvPrice, id} = product;
            
            // 2022-api : 
            // const {name:Name, id:Id, image:ThumbImageUrl, salePrice:CustPrice, pvPrice:PvPrice} = ProductInfo;
            let totalPV;
            let totalPrice;
            let id;
            let ThumbImageUrl;
            let quantity;
            let name;

            if (GentleAppState.isLogin) {
                totalPV = elementLoginCheck().totalPointValue;
                totalPrice = elementLoginCheck().totalPrice;
                id = productLoginCheck().id;
                ThumbImageUrl = productLoginCheck().imageUrl;
                quantity = elementLoginCheck().quantity;
                name = productLoginCheck().name
            }else {
                totalPV = productLoginCheck().PvPrice * elementLoginCheck().Qty;
                totalPrice = productLoginCheck().CustPrice * elementLoginCheck().Qty;
                id = productLoginCheck().id;
                ThumbImageUrl = productLoginCheck().ThumbImageUrl;
                quantity = elementLoginCheck().Qty;
                name = productLoginCheck().name
            }
            // console.log(totalPV, totalPrice)
            // let totalPV = PvPrice * Qty;
            // totalPV = totalPointValue;
            totalPV = GentleUtil.comma(totalPV);

            // let totalPrice = CustPrice * Qty;
            totalPrice = GentleLang.translate(GentleLang.type.CurrencyFormat1, {num: GentleUtil.comma(totalPrice)});

            let htmlCard = `
            <li name="cart-${id}">
                <div class="product-container">
                    <div class="product-card ">
                        <figure class="product-thumbnail">
                            <img src="${ThumbImageUrl}">
                        </figure>
                        <div class="product-summary-container">
                            <!--<div class="flex-box flex-align-top">-->
                                <h3>${name}</h3>
                                <img src="/assets/images/atomy/cart-remove.svg" class="cart-remove" name="delete">
                            <!--</div>-->                            
                            <div class="flex-box space-between flex-align-center">
                                <span>${titleAmount}</span>
                                <div class="qty-group flex-box">
                                    <span class="plus" name="minus"><img src="/assets/images/atomy/cart-minus.svg"></span>
                                    <input type="text" readonly value="${quantity}" name="quantity">
                                    <span class="minus" name="plus"><img src="/assets/images/atomy/cart-plus.svg"></span>
                                </div>
                            </div>
                            <div class="flex-box space-between">
                                <span>${titleOrderTotalPrice}</span>
                                <span name="totalPrice">${totalPrice}</span>
                            </div>
                            <div class="flex-box space-between">
                                <span>${titleTotalPv}</span>
                                <span><strong class="pv" name="totalPV">${totalPV}</strong> PV</span>
                            </div>
                        </div>
                    </div>
                </div>
            </li>                
            `;

            element.button_title = titleButton;
            
            const $card = $(htmlCard);
            const $totalPrice = $card.find('[name="totalPrice"]');
            const $totalPV = $card.find('[name="totalPV"]');        

            // 삭제 
            $card.find('[name="delete"]').bind('click', function(){
                // console.log("삭제시도 : ", Id);

                const didDeleted = function(Id){
                    // remove product 
                    console.log('deleted ', Id);
                    $container.find(`[name="cart-${Id}"]`).remove();

                    element.quantity = 0;
                    // todo : delete elment
                    // array.splice(index, 1);

                    console.log('Id', Id);
                    for (let i = 0; i < array.length; i++) {
                        const item = array[i];

                        if(GentleAppState.isLogin){
                            const {product} = item;

                            console.log('item>', item);
                            if(product.id === Id){
                                array.splice(i, 1);
                            }  
                        }else {
                            const {ProductInfo} = item;

                            console.log('item>', item);
                            if(ProductInfo.id === Id){
                                array.splice(i, 1);
                                window.chatbotCart.splice(i, 1);
                            }  
                        }
                        // const {product} = item;

                        // console.log('item>', item.id);
                        // if(item.id === Id){
                        //     console.log(window.chatbotCart)
                        //     array.splice(i, 1);
                            
                        //     window.chatbotCart.splice(i, 1);
                        // }                        
                    }

                    updateTotal(array);
                }
                const failed = function(){
                    // console.log('삭제 실패');
                }

                console.log('GentleAppState.isLogin', GentleAppState.isLogin);
                if(GentleAppState.isLogin) // 로그인중이라면
                {
                    console.log('element>', element);
                    del(element.cartNo, didDeleted(productLoginCheck().id), failed);
                }
                else // 비로그인이라면 로컬에서 지운다.
                {
                    // console.log('비로그인 상태')
                    didDeleted(productLoginCheck().id);                
                }
            });

            const $Qty = $card.find('[name="quantity"]');
            const $quantity = $card.find('[name="quantity"]');


            const updateValue = function(){
                console.log('updateValue.totalPV', element);   

                if(GentleAppState.isLogin){
                    let totalPV = element.product.pvPrice * element.quantity;
                    totalPV = GentleUtil.comma(totalPV);
                    $totalPV.html(totalPV);
                    let totalPrice = element.product.salePrice * element.quantity;

                    totalPrice = GentleLang.translate(GentleLang.type.CurrencyFormat1, {num: GentleUtil.comma(totalPrice)});    
                    $totalPrice.html(totalPrice);
    
                    updateTotal(array);
                }else {
                    let totalPV = element.ProductInfo.PvPrice * element.Qty;
                    totalPV = GentleUtil.comma(totalPV);
                    $totalPV.html(totalPV);
        
                    let totalPrice = element.ProductInfo.CustPrice * element.Qty;;
                    totalPrice = GentleLang.translate(GentleLang.type.CurrencyFormat1, {num: GentleUtil.comma(totalPrice)});    
                    $totalPrice.html(totalPrice);
    
                    updateTotal(array);
                }
            }

            const callback = function(sum){
                element.quantity = sum;
                $quantity.val(element.quantity);
                updateValue();
            }

            const failed = function(){
                console.log('업데이트 실패');
            }

            // 수량 +
            $card.find('[name="plus"]').bind('click', function(){
                if(GentleAppState.isLogin){
                    console.log('element>', element);
                    requestUpdate(element.cartNo, element.quantity+1, callback, failed);
                    updateValue();
                }
                else{
                    console.log('비로그인 수량변경', index,element);
                    // array[index].quantity = element.quantity+1;

                    const perPrice = window.chatbotCart[index].totalPrice / window.chatbotCart[index].amount;
                    const perPV = window.chatbotCart[index].totalPv / window.chatbotCart[index].amount;

                    element.Qty = element.Qty+1;
                    $Qty.val(element.Qty);
                    updateValue();

                    // 장바구니 갱신
                    {
                        window.chatbotCart[index].amount = element.Qty;
                        window.chatbotCart[index].totalPrice = perPrice * element.Qty;
                        window.chatbotCart[index].totalPv = perPV * element.Qty;
                        console.log('window.chatbotCart[index]', window.chatbotCart[index]);
                    }
                }
            });

            // 수량 -
            $card.find('[name="minus"]').bind('click', function(){

                if(GentleAppState.isLogin){
                    if(element.quantity <= 1) return;
                    requestUpdate(element.id, element.quantity-1, callback, failed);
                    updateValue();
                }
                else {
                    if(element.Qty <= 1) return;
                    const perPrice = window.chatbotCart[index].totalPrice / window.chatbotCart[index].amount;
                    const perPV = window.chatbotCart[index].totalPv / window.chatbotCart[index].amount;

                    console.log('비로그인 수량변경');
                    element.Qty = element.Qty-1;
                    $Qty.val(element.Qty);
                    updateValue();

                    // 장바구니 갱신
                    {
                        window.chatbotCart[index].amount = element.Qty;
                        window.chatbotCart[index].totalPrice = perPrice * element.Qty;
                        window.chatbotCart[index].totalPv = perPV * element.Qty;
                        console.log('window.chatbotCart[index]', window.chatbotCart[index]);
                    }
                }
            });
            
            $list.append($card);
        }
        GentleUtil.createSlidePopup({title, content: $container});
    };

    // api
    const request = function(){
        const pageSize = 5;

        const onSuccess = function(data){
            console.log('onSuccess>', data);
            switch(data.result){
            case "200":
                const { items } = data;
                console.log('Data>', items);
                
                render(items);
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        // const param = {page: page+1, size:pageSize};
        // proxy.request("global-cartList", {}, onSuccess, onFailed );
        proxy.request("2025-cartList", {}, onSuccess, onFailed );
    }

    request();

    const del = function(productCodes, callback, failed){
       // api
       console.log('del>', productCodes);
       const request = function(){
           const onSuccess = function(data){
            console.log('onSuccess>', data);
               switch(data.result){
               case "200":
                   console.log('삭제완료')
                   callback;
                   break;
               default:
                failed();
                break;
               }
           };
       
           const onFailed = function(data){
               failed();
           }

            const proxy = Object.create(GentleProxy);
            const param = {
                cartNoList: [productCodes]
            }


        //    proxy.requestFormData("global-cartDel", deleteFormData, onSuccess, onFailed );
           proxy.requestEx({proxy:"2025-cartDel", param, onSuccess, onFailed, isHidden: true});           
       }
       request();
    }

    const requestUpdate = function(Id, Qty, callback, failed){
       // api
       const request = function(){
           const onSuccess = function(data){
            console.log('onSuccess>', data);
               switch(data.result){
               case "200":
                   const { Data } = data;
                   console.log('수정완료')
                //    console.log('Data>', Data);
                   callback(Qty);
                   break;
               default:
                   break;
               }
           };
       
           const onFailed = function(data){
               failed();
           }
   
           const proxy = Object.create(GentleProxy);
           const param = {
                // entry: Id,
                // quantity: Qty,
                cartNo: Id,
                quantity: Qty,
            };

            // const updateFormData = new FormData(); // new FromData()로 새로운 객체 생성
            // updateFormData.append('cartNo', param.entry);
            // updateFormData.append('quantity', param.quantity);
    
        //    proxy.requestFormData("global-cartUpdate", updateFormData, onSuccess, onFailed );
           proxy.requestEx({proxy:"2025-cartUpdate", param, onSuccess, onFailed, isHidden: true});
       }
       request();
    }
}

 
 export default GentleServiceCart;